import Board from './Board';
import { obDefaultValGet } from '../common/common';

export default class Game {
    constructor(initOb=null) {
        this.id = obDefaultValGet(initOb, 'id', ''); 
        this.player = {
            list: {}
        };
        this.option = {};
        this.board = new Board();
        this.status = obDefaultValGet(initOb, 'status', ''); 

        if (initOb!==null) {
            if ('option' in initOb) {
                this.option = { ...initOb.option };                
            }
            this.player.list = { ...initOb.player.list };
            if ('board' in initOb) {
                this.board = new Board(initOb.board);
            }
        }        
    }

    get code() {
        let code = '';
        if ('code' in this.option) {
            code = this.option.code;            
        }
        return code;
    }

    playerScore(userId) {
        return this.board.playerScore(userId);
    }

    playerColorGet(userId) {
        let playerColor = '#ffffff';
        if (userId in this.player.list) {
            playerColor = this.player.list[userId].color;       
        }        
        return playerColor;
    }

    get isComplete() {
        return this.status === 'complete';
    }

    get maxScore() {
        let max = 0;
        // this.player.list
        return max;
    }

    get playerSortScore() {
        let uIdN = Object.keys(this.player.list);
        uIdN = uIdN.sort((uId1, uId2) => {
            return this.playerScore(uId2) - this.playerScore(uId1);
        });
        const playerN = uIdN.map(userId => {
            const score = this.playerScore(userId);
            let playerOb = {
                userId,
                score,
            };
            Object.assign(playerOb, this.player.list[userId]);
            return playerOb;
        });
        return playerN;
    }

    get playerMaxScore() {
        let playerN = [];
        const playerSortN = this.playerSortScore;     
        const maxScore = playerSortN[0].score;
        for (let i = 0; i < playerSortN.length; i++) {
            const player = playerSortN[i];
            if (player.score < maxScore) {
                break;                
            }
            playerN.push(player);            
        }
        return playerN;
    }
}